<template>
  <div>
    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div
        class="col-md-12 text-right"
        style="flex-wrap: wrap; margin-bottom: 10px"
      >
        <btn-rounded
          class="text-right"
          :label="'NOVO'"
          event="novo"
          :active-color="'success'"
        />

        <btn-rounded
          class="text-right"
          :label="filter ? 'LIMPAR' : 'FILTRO'"
          event="showFilter"
          :active-color="filter ? 'danger' : 'primary'"
        />
      </div>

      <div v-if="filter">
        <div class="row" style="padding: 5px" text-center>
          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Inicial"
              :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Final"
              :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd"
            />
          </div>
        </div>

        <div class="row" style="padding: 5px" text-center>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Busca"
              placeholder="Nome, Email..."
              v-model="filterOptions.term"
            />
          </div>
        </div>

        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded
                class="text-right"
                label="FILTRAR"
                event="activeFilter"
                active-color="success"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table
            eventName="selectItem"
            :title="table.title"
            :sub-title="table.subTitle"
            :data="list || auctionList"
            :columns="table.columns"
            :headers="table.headers"
            :control="table.control"
          />
        </div>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
const headers = [
  "Código",
  "Veículo",
  "Placa",
  "Descrição",
  "Valor inicial",
  "Prazo",
  "Número de ofertas",
  "Status",
  "Data Cadastrado",
];
const tableColumns = [
  "Car.code",
  "Car.name",
  "Car.plate",
  "Car.description",
  "formattedInitialOffer",
  {
    columnName: "deadline",
    logic: function(data, columnData) {
      if (!data) {
        return "";
      }
      return data.replaceAll("-", "/");
    },
  },
  {
    columnName: "AuctionOffers",
    logic: function(data, columnData) {
      if (data.length == 0) {
        return 0;
      } else {
        return data.length;
      }
    },
  },
  {
      columnName: "isDeadline",
      logic: function (data) {
        let className = 'text-danger';
        let val = 'Encerrado';
        if (!data) {
          className = 'text-success';
          val = 'Ativo';
        }
        let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

        return `${prefix} ${val}`
      }
    },
  {
    columnName: "createdAt",
    logic: function(data, columnData) {
      if (!data) {
        return "";
      }
      return moment
        .utc(data)
        .utcOffset(0)
        .format("DD/MM/YYYY H:mm:ss");
    },
  },
];
const control = [
  {
    event: "deleteAuction",
    class: "ti-trash btn btn-danger btn-sm",
  },
];

export default {
  components: {
    ComponentTable,
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },

  computed: {
    ...mapState({
      auctionList: ({ auction }) => auction.list,
    }),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
  },

  methods: {
    ...mapActions(["getAuctionList", "deleteAuction"]),

    setPage: function(page) {
      this.page = page;
    },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      this.getAuctionList(this.filterOptions);
    },
  },

  created() {
    this.cleanFilter();

    this.$on("novo", () => {
      this.$router.push({
        name: "Ofertas - Criar",
      });
    });
    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
      // this.filter = !this.filter;
    });

    this.$on("selectItem", (item) => {
      console.log(item)
      this.$router.push({
        name: "Ofertas - Editar",
        params: { id: item },
      });
    });

    this.$on("deleteAuction", (item) => {
      this.$modal.show("dialog", {
        title: "Excluir Oferta",
        text: "Tem certeza que deseja excluir essa Oferta?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              this.deleteAuction(item)
                .then((res) => {
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: res.msg,
                    position: "top center",
                    type: "success",
                  });
                  const index = this.auctionList.indexOf(item, 0);
                  if (index > -1) {
                    this.auctionList.splice(index, 1);
                  }
                })
                .catch((res) => {
                  this.$notify({
                    group: "foo",
                    title: res.msg,
                    text: res.info,
                    position: "top center",
                    type: "error",
                  });
                });

              this.$modal.hide("dialog");
            },
          },
          {
            title: "Não", // Button title
            handler: () => {
              this.$modal.hide("dialog");
            }, // Button click handler
          },
        ],
      });
    });
  },

  data() {
    return {
      page: 1,
      table: {
        title: "Ofertas",
        subTitle: "Lista de Ofertas cadastrados",
        headers: [...headers],
        columns: [...tableColumns],
        control: [...control],
      },
      filter: false,
      filterOptions: {
        isAdmin: undefined,
        idActive: undefined,
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Auction/AuctionList.vue